import { render, staticRenderFns } from "./supplierStatement.vue?vue&type=template&id=db25cff6&scoped=true&"
import script from "./supplierStatement.vue?vue&type=script&lang=js&"
export * from "./supplierStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db25cff6",
  null
  
)

export default component.exports